import React from 'react';
import PropTypes from 'prop-types';

import { TableFooter, TableCell, TableRow } from '../TableComponents';
import ScorePointer from './ScorePointer';
import { COLOR } from '../../Theme';

const TableFooterSection = ({ columns, score, color, scoreVariant }) => (
  <TableFooter>
    <TableRow noBorder={true} bgColor={COLOR.gridGrey}>
      <TableCell />
      <TableCell />
      {columns.map((column, index) => {
        return score.columnIndex === index ? (
          <ScorePointer key={index} score={score.value} color={color} scoreVariant={scoreVariant} />
        ) : (
          <TableCell key={index} />
        );
      })}
      <TableCell />
    </TableRow>
  </TableFooter>
);

export default TableFooterSection;
